'use strict';

import Config from './config';

export default class Log {

    static info(message) {
        if (this.isActive === true) {
            console.info(message);
        }
    }

    static warn(message) {
        if (this.isActive === true) {
            console.warn(message);
        }
    }

    static error(message) {
        if (this.isActive === true) {
            console.error(message);
        }
    }

    static print(message) {
        if (this.isActive === true) {
            console.log(message);
        }
    }

    static active() {
        this.isActive = true;
    }

    static disable() {
        this.isActive = false;
    }
}



// WEBPACK FOOTER //
// ./src/log.js